module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/record-data/record-data.component.scss
// module id = ./src/app/components/record-data/record-data.component.scss
// module chunks = main